import Menu from './Menu/Routes';
import Routes from './Route/Routes';
import UserGroup from './UserGroup/Routes';
import PurchaseCommittee from './PurchaseCommittee/Routes';
import UserType from './UserType/Routes';



export default [...Routes, ...Menu, ...UserGroup, ...PurchaseCommittee, ...UserType];